import { FaceTecSDK } from "../../../core-sdk/FaceTecSDK.js/FaceTecSDK";
var UserFriendlyMessages = /** @class */ (function () {
    function UserFriendlyMessages() {
    }
    UserFriendlyMessages.getMessageForStatus = function (status) {
        switch (status) {
            case FaceTecSDK.FaceTecSessionStatus.SessionCompleted:
                return {
                    text: "✓ Verificación completada exitosamente",
                    type: "success"
                };
            case FaceTecSDK.FaceTecSessionStatus.CameraPermissionsDenied:
                return {
                    text: "Necesitamos acceso a tu cámara para continuar",
                    type: "error",
                    action: "Habilitar cámara"
                };
            case FaceTecSDK.FaceTecSessionStatus.UserCancelledFaceScan:
                return {
                    text: "Proceso cancelado. Puedes intentar nuevamente",
                    type: "warning",
                    action: "Reintentar"
                };
            case FaceTecSDK.FaceTecSessionStatus.UserCancelledIDScan:
                return {
                    text: "Escaneo de documento cancelado. Intenta nuevamente",
                    type: "warning",
                    action: "Reintentar"
                };
            case FaceTecSDK.FaceTecSessionStatus.LockedOut:
                return {
                    text: "Demasiados intentos fallidos. Por favor intenta más tarde",
                    type: "error"
                };
            case FaceTecSDK.FaceTecSessionStatus.CameraError:
                return {
                    text: "Error con la cámara. Verifica que esté funcionando correctamente",
                    type: "error",
                    action: "Reintentar"
                };
            case FaceTecSDK.FaceTecSessionStatus.RequestAborted:
                return {
                    text: "Error de conexión. Verifica tu internet e intenta nuevamente",
                    type: "error",
                    action: "Reintentar"
                };
            case FaceTecSDK.FaceTecSessionStatus.UnknownInternalError:
            default:
                return {
                    text: "Ocurrió un problema. Por favor intenta nuevamente",
                    type: "error",
                    action: "Reintentar"
                };
        }
    };
    return UserFriendlyMessages;
}());
export { UserFriendlyMessages };
